var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cmp-card-items-list ws-typography"},[_c('div',{staticClass:"domains row justify-between items-stretch",class:{
      'q-col-gutter-lg': _vm.desktop || _vm.tablet,
      'q-col-gutter-sm': _vm.mobile,
      'q-px-sm': _vm.mobile,
    },style:(_vm.customSize)},_vm._l((_vm.items),function(item){return _c('div',{key:item.name,staticClass:"col-12",class:{ 'col-md-6': _vm.numberOfItems < 3, 'col-md-4': _vm.numberOfItems >= 3 }},[_c('product-item',{attrs:{"item":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }